import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/mock';
import { Star } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const Reviews = () => {
  const { t } = useLanguage();
  const reviewsText = t(translations.reviews);

  return (
    <div className="min-h-screen">
      {/* Page Header */}
      <section className="bg-gradient-to-r from-[#0B1F3F] to-[#1a3a5f] text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{reviewsText.title}</h1>
          <p className="text-xl text-gray-200">{reviewsText.subtitle}</p>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviewsText.testimonials.map((review, index) => (
              <Card key={index} className="hover:shadow-xl transition-shadow duration-300 border-2 border-gray-100">
                <CardContent className="p-6">
                  {/* Star Rating */}
                  <div className="flex mb-4">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} className="h-5 w-5 text-yellow-400 fill-yellow-400" />
                    ))}
                  </div>
                  
                  {/* Review Text */}
                  <p className="text-gray-700 mb-4 leading-relaxed italic">"{review.text}"</p>
                  
                  {/* Reviewer Name */}
                  <div className="pt-4 border-t border-gray-200">
                    <p className="font-semibold text-[#0B1F3F]">{review.name}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Reviews;
